/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ qty: NonNullable<unknown>, unit: NonNullable<unknown> }} Pos_Shelf_Stock_BadgeInputs */

const vi_pos_shelf_stock_badge = /** @type {(inputs: Pos_Shelf_Stock_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Trên kệ: ${i?.qty} ${i?.unit}`)
};

/**

* @param {Pos_Shelf_Stock_BadgeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_shelf_stock_badge = /** @type {((inputs: Pos_Shelf_Stock_BadgeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Shelf_Stock_BadgeInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_shelf_stock_badge(inputs)
});